import {__} from "./__";

export const getAiFunctionNames = () => {
    return {
        'Generate product name by EAN': __('Vygeneruje názov produktu na základe EAN'),
        'Generate product parameters by EAN': __('Vygeneruje parametre produktu na základe EAN'),
        'Generate product short description by EAN': __('Vygeneruje krátky popis produktu na základe EAN'),
        'Generate product description by EAN': __('Vygeneruje dlhý popis produktu na základe EAN'),
        'Generate product parameters': __('Vygeneruje parametre produktu na základe informácii o produkte'),
        'Generate product short description': __('Vygeneruje krátky popis produktu na základe informácii o produkte'),
        'Generate product description': __('Vygeneruje dlhý popis produktu na základe informácii o produkte'),
        'Generate product SEO title': __('Vygeneruje SEO (meta) názov produktu na základe informácii o produkte'),
        'Generate product SEO description': __('Vygeneruje SEO (meta) popis produktu na základe informácii o produkte'),
        'Translates text into the selected language': __('Preloží text na základe zvoleného jazyka'),
        'Generate category short description': __('Vygeneruje krátky popis kategórie na základe informácii o kategórii'),
        'Generate category description': __('Vygeneruje dlhý popis kategórie na základe informácii o kategórii'),
        'Generate category SEO title': __('Vygeneruje SEO (meta) názov kategórie na základe informácii o kategórii'),
        'Generate category SEO description': __('Vygeneruje SEO (meta) popis kategórie na základe informácii o kategórii'),
        'Generate product EAN by name': __('Vygeneruje EAN na základe názvu produktu'),
    };
};
